<template>
  <div class="message-time">
    <span v-if="message.loading"><TimeIcon class="time-icon" /></span>
    <span v-else-if="message.error">
      <button type="button" class="btn-link mr-8" @click="$emit('resend')">
        {{ $t('Resend') }}
      </button>
      <button type="button" class="btn-link mr-8" @click="$emit('delete')">
        {{ $t('Delete') }}
      </button>
      <ErrorIcon />
    </span>
    <span v-else>
      {{ time }}
    </span>
  </div>
</template>

<script>
  import time from '@/utils/date/time';
  import TimeIcon from '@/assets/icons/time.svg';
  import ErrorIcon from '@/assets/icons/error-red.svg';

  export default {
    name: 'MessageStatus',
    components: {
      TimeIcon,
      ErrorIcon,
    },
    props: {
      message: {
        type: Object,
        required: true,
      },
    },
    computed: {
      time() {
        return time(this.message.updated_at);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .message-time {
    height: 20px;
  }

  .time-icon {
    max-width: 16px;
  }
</style>
